import Styles from './ScheduleStatusBanner.module.scss'
import { AlertTriangle } from 'blaze-ui/icons'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useCrossPostAccountsToConnectCount } from 'hooks/useCrossPostAccountsToConnectCount'
import { BrandPlanSchedule } from 'types'
import { pluralize } from 'utils'
import { useMemo } from 'react'
import { useModals } from 'almanac-ui/Modal'
import { ActivationConnectModal } from 'components/ActivationConnectModal/ActivationConnectModal'

export const WarningCircle = ({ schedule }: { schedule: BrandPlanSchedule }) => {
  const { openModal } = useModals()
  const { accountsToConnectCount, crossPostGroup } = useCrossPostAccountsToConnectCount(schedule?.tactics ?? [])

  const tooltipLabel = useMemo(() => {
    if (accountsToConnectCount > 0 && crossPostGroup.length === accountsToConnectCount) {
      return `Connect ${accountsToConnectCount} ${pluralize('account', accountsToConnectCount)} to start auto-posting`
    }
    return `${crossPostGroup.length - accountsToConnectCount} of ${crossPostGroup.length} ${pluralize(
      'account',
      crossPostGroup.length,
    )} connected`
  }, [accountsToConnectCount, crossPostGroup])

  const handleClick = () => {
    openModal(ActivationConnectModal, {})
  }

  return (
    <Tooltip label={tooltipLabel} placement="top">
      <div className={Styles.warningCircle} onClick={handleClick} data-testid="warning-circle">
        <AlertTriangle size={15} color="var(--dark-90)" />
      </div>
    </Tooltip>
  )
}
